import { apiFetch } from '@/lib/api'

export async function apiCreateTimeline(showId, payload) {
  const res = await apiFetch(`/api/shows/${showId}/timelines`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
  if (!res.ok) throw new Error('Failed to create timeline')
  return res.json()
}

export async function apiLoadTimeline(showId, timelineId) {
  const res = await apiFetch(`/api/shows/${showId}/timelines/${timelineId}`)
  if (!res.ok) throw new Error('Failed to load timeline')
  return res.json()
}

export async function apiSaveTimeline(showId, timelineId, payload) {
  const res = await apiFetch(`/api/shows/${showId}/timelines/${timelineId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
  if (!res.ok) throw new Error('Failed to save timeline')
  return res.json()
}

export async function apiListTimelines(showId, { sortBy = 'updatedAt', sortDir = 'desc', own = false, search = '', page = 1, size = 25 } = {}) {
  const params = new URLSearchParams({ sortBy, sortDir, page, size })
  if (own) params.set('own', 'true')
  if (search) params.set('search', search)
  const res = await apiFetch(`/api/shows/${showId}/timelines?${params}`)
  if (!res.ok) throw new Error('Failed to list timelines')
  return res.json()
}

export async function apiDeleteTimeline(showId, timelineId) {
  const res = await apiFetch(`/api/shows/${showId}/timelines/${timelineId}`, {
    method: 'DELETE',
  })
  if (!res.ok) throw new Error('Failed to delete timeline')
  return res.json()
}
